import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  token: null,
  userId: null,
  invite_type: null,
  org_id: null,
  orgId: null,
  loginuserdata: null,
  logindata: {},
  user: null,
  isAuthenticated: false,
  selectedApplication: "MISSION-EXPLORER",
};

// Create a slice of the state
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action) {
      const payload = action.payload || {};
      const loginData = payload.logindata || payload.user || {};

      state.token = payload.token || null;
      state.userId = payload.userId || loginData._id || null;
      state.org_id = payload.org_id || payload.orgId || loginData.org_id || null;
      state.orgId = payload.orgId || payload.org_id || loginData.org_id || null;
      state.loginuserdata = payload.loginuserdata || loginData.username || null;
      state.invite_type = payload.invite_type || loginData.invite_type || null;
      state.isAuthenticated = true; // Set to true when token is set
      state.logindata = loginData;
      state.user = loginData;
    },
    logout(state) {
      state.token = null;
      state.userId = null;
      state.org_id = null;
      state.orgId = null;
      state.invite_type = null;
      state.loginuserdata = null;
      state.isAuthenticated = false; // Set to false on logout
      state.logindata = {};
      state.user = null;
    },
    setSelectedApplication(state, action) {
      state.selectedApplication = action.payload;
    },
  },
});

// console.log(authSlice.payload)
export const { setToken, logout, setSelectedApplication } = authSlice.actions;
export default authSlice.reducer;
